export default "__VITE_ASSET__BRksr6Q6__"